import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { sitemapSections } from '@/mocks/sitemapData';

export default function SitemapContent() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('sitemap.content.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('sitemap.content.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('sitemap.content.subtitleEn')}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {sitemapSections.map((section) => (
            <div
              key={section.id}
              className="card-glow bg-background-100/60 border border-background-200/60 p-6"
            >
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-1">
                {t(`sitemap.sec.${section.id}.title`, { defaultValue: section.title })}
              </h3>
              <p className="text-accent-500 text-[13px] tracking-[0.1em] mb-3 font-label">
                {section.titleEn}
              </p>
              <p className="text-[13px] text-foreground-400 tracking-[0.04em] leading-relaxed mb-4">
                {t(`sitemap.sec.${section.id}.desc`, { defaultValue: section.description })}
              </p>

              <ul className="space-y-1.5">
                {section.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    <Link
                      to={link.href}
                      className="inline-flex items-center gap-2 text-[15px] text-foreground-600 hover:text-accent-600 tracking-[0.04em] transition-colors group"
                    >
                      <div className="w-3.5 h-3.5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-right-s-line text-accent-400 text-xs group-hover:translate-x-0.5 transition-transform"></i>
                      </div>
                      {t(`sitemap.sec.${section.id}.link.${linkIdx}`, { defaultValue: link.label })}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-10">
          {t('sitemap.content.lead')}
        </p>
      </div>
    </section>
  );
}